import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { Packs } from "@/components/Packs";
import { Audiences } from "@/components/Audiences";
import { Journeys } from "@/components/Journeys";
import { Steps } from "@/components/Steps";
import { Booking } from "@/components/Booking";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { PaymentSuccess, PaymentCancel } from "@/components/PaymentResult";

const Landing = ({ prefill, onPrefill }) => (
  <>
    <Header />
    <main>
      <Hero />
      <Marquee />
      <Audiences />
      <Services />
      <Journeys />
      <Gallery />
      <Packs />
      <Steps />
      <Booking prefill={prefill} />
      <Contact />
    </main>
    <Footer />
    <ChatWidget onPrefill={onPrefill} />
  </>
);

function App() {
  const [devisPrefill, setDevisPrefill] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -70, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="bg-[#0A0D14] min-h-screen text-white antialiased">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing prefill={devisPrefill} onPrefill={setDevisPrefill} />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </div>
    </MotionConfig>
  );
}

export default App;
